import { createStore } from 'vuex';
import { locationFormatter } from '@/utils';
import dbc from '../api/downloadPage';
export default createStore({
  state: {
    env: {},
    code: '',
    sourceConfig: {},
    downloadItems: [
      {
        name: 'Windows',
        downBtnText: '',
        displayLogo: 'hci-windows',
        downloadType: 'click',
        descriptionTextShow: 'windows',
      },
      {
        name: 'MacOS',
        downBtnText: 'supportM1',
        displayLogo: 'hci-app-store',
        downloadType: 'click',
        descriptionTextShow: 'macOS',
      },
      {
        name: 'Ios',
        downBtnText: 'supportDifferentRegion',
        downTipText: 'supportDifferentRegionTip',
        displayLogo: 'hci-apple',
        downloadType: 'scan',
        descriptionTextShow: 'iOS&iPadOS',
      },
      {
        name: 'Android',
        downBtnText: '',
        displayLogo: 'hci-android',
        downloadType: 'scan',
        descriptionTextShow: 'android',
      },
      {
        name: 'Linux',
        downBtnText: 'supportDebx64',
        displayLogo: 'hci-linux',
        downloadType: 'click',
        descriptionTextShow: 'linux',
      },
    ],
  },
  getters: {},
  mutations: {
    getEnv(state) {
      const ua = window.navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      const isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
      const isWechat =
        ua.indexOf('micromessenger') > -1 || ua.indexOf('WeChat') > -1;
      const isIpad =
        ua.indexOf('ipad') > -1 ||
        (window.navigator.platform === 'MacIntel' &&
          window.navigator.maxTouchPoints > 1 &&
          !window.MSStream &&
          'ontouchend' in document);
      const isMacOS = /macintosh|mac os x/i.test(ua) && !isIos;
      const isMobile = isAndroid || isIos || isIpad;
      const isPC = !isMobile;
      const isWindows = /windows|win32/i.test(ua);
      const isDouyin = ua.indexOf('aweme') > -1;
      const isToutiao = ua.indexOf('newsarticle') > -1;
      const isHuoshan = ua.indexOf('live_stream') > -1;
      const isXigua = ua.indexOf('videoarticle') > -1;
      const isByteDance = isDouyin || isToutiao || isHuoshan || isXigua;
      const isLightHouse = ua.indexOf('lighthouse') > -1;
      state.env = {
        isAndroid,
        isIos,
        isWechat,
        isMobile,
        isPC,
        isMacOS,
        isWindows,
        isDouyin,
        isToutiao,
        isHuoshan,
        isXigua,
        isByteDance,
        isIpad,
        isLightHouse,
      };
      console.log('env', state.env);
    },
    setSourceConfig(state, content) {
      const downloadItems = state.downloadItems;
      console.log('qr_link', content);
      for (const item of downloadItems) {
        // 2023.04.03字段修改qr_link -> qrLink dyf
        item.qr_link = content[item.name].qrLink;

        if (item.name !== 'MacOs') {
          item.link = content[item.name].link;
        } else {
          item.link = [content.MacOs.link, content.MacOS_m1.link];
        }
      }
      state.sourceConfig = content;
      state.downloadItems = downloadItems;
      console.log('downloadItems', content);
    },
    setCode(state, content) {
      console.log('exchangeCode', content);
      state.code = content;
    },
  },
  actions: {
    getPageData({ commit }) {
      console.log('env', this.state.env);
      dbc.getSourceConfig({ isIpad: this.state.env.isIpad }).then(result => {
        commit('setSourceConfig', result.data);
      });
    },
    getCode({ commit }, region) {
      dbc.getCode({ region }).then(({ data }) => {
        commit('setCode', data.code);
      });
    },
    getLocation() {
      return dbc
        .getLocation()
        .then(res => locationFormatter(res.data))
        .catch(() => '');
    },
  },
  modules: {},
});
